import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);

// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* layout */
const Layout= _import("layout/Layout");
/* layout */
import LayoutSystem from '../views/layout/LayoutSystem';

/* error page */
const Err404 = _import('error/404');
const Err401 = _import('error/401');
/* login */
const Login = _import('login/index');
const sysPermission = _import('sysPermission/list');



const Index = _import('finance/statistical-analysis');
const Device = _import('device/list');
const bleDevice = _import('bleDevice/list');
const bleDeviceUser = _import('bleDeviceUser/list');

/**用户 管理*/

const User = _import('user/list');
/**类目管理*/

const categoryList = _import('category/list');

/**demo**/
const Demo = _import('demo/list');
const Demo1 = _import('demo/list1');
const Details = _import('demo/details');



const operationRecord = _import('device/device_operation_log_list');
const bleDeviceOperationRecord = _import('bleDevice/device_operation_log_list');




/**系统管理**/
const AccountList = _import('system/account-list');
const RoleList = _import('system/role-list');
const OperationLog = _import('system/operation-log');
const AppAdminList = _import('system/app-admin-list');
const AppAdminLockList = _import('system/app-admin-lock-list');


//运营管理
const PayPackage = _import('operationBusiness/pay-package-list');
const Notice = _import('operationBusiness/notice-list');
const distributorList = _import('operationBusiness/distributor-list');
const grantPermission = _import('operationBusiness/temp-grant-permission');
const tempGrantPermissionLog = _import('operationBusiness/temp-grant-permission-log');
const studentDiscountSet = _import('operationBusiness/student-discount-set');

const houqinbaoUserList = _import('operationBusiness/houqinbao-user-list');
const deviceReturnRent = _import('deviceReturnRent/list');
/**
 * 轮播管理
 */
const banner = _import('banner/list');

const apiTest = _import('apiTest/list');

const shareRecordList = _import('shareRecord/list');
//信息管理
const student = _import('information/student-list');

const studentDetails = _import('information/student-details');

const areaList = _import('information/area-list');
const roomList = _import('information/room-list');
const projectList = _import('information/project-list');
const userMobileNumberChangeRecord = _import('information/user-mobile-number-change-record');
const userSignInRecord = _import('information/user-sign-in-record');




//财务管理
const incomeList = _import('finance/income-list');
const depositList = _import('finance/deposit-list');
const depositRefundList = _import('finance/deposit-refund-list');
const incomeRefundList = _import('finance/income-refund-list');
const statisticalAnalysis = _import('finance/statistical-analysis');
const userWithdrawalList = _import('finance/user-withdrawal-list');




//产品管理
const productList = _import('product/list');
const productDetails = _import('product/details');

//生产管理

const productionControl = _import('productionControl/list');

const partOrder = _import('partOrder/list');
const tenant = _import('tenant/list');

//店铺待结账订单
const shopUnpaidOrderList = _import('shopOrder/order-unpaid-list');


//上报记录
const deviceReportRecord = _import('deviceReportRecord/list');

const stockRecord = _import('stockRecord/list');

//九号
const jiuhaoRecord = _import('jiuhao/list');
const jiuhaoErrorCodeConfig = _import('jiuhao/jiuhao-error-code-config');
const generateCode = _import('sysCodeGenerationRecord/list');


//bleOperationRecord

const shopList = _import('shop/list');
const pddShopList = _import('pddShop/list');

const shopAuthCallback = _import('shop/shop-auth-callback');


const toolCommentInfoList = _import('toolCommentInfo/list');


const toBeShippedList = _import('productionControl/to-be-shipped-list');



Vue.use(Router);
export const constantRouterMap = [
    { path: '/login', component: Login, hidden: true },

    { path: '/404', component: Err404, hidden: true },
    { path: '/401', component: Err401, hidden: true },
    {
        path: '/',
        redirect: '/login',
        name: '首页',
        hidden: true
    }

]

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
});

export const asyncRouterMap = [
    {
        path: '/admin',
        component: Layout,
        icon: 'el-icon-s-home',
        showOnly: true,
        children: [{
            path: 'index',
            component: Index,
            name: '首页',
            icon: 'el-icon-s-home',
            showOnly: true,
        }]
    },




    /*  {
          path: '/admin',
          component: Layout,
          icon: 'el-icon-s-custom',
          showOnly: true,
          children: [{
                  path: 'user',
                  component: User,
                  name: '会员管理',
                  meta: "device"
              }
    
          ]
      },*/


    /* {
         path: '/admin',
         component: Layout,
         icon: 'el-icon-s-custom',
         showOnly: true,
         children: [{
                 path: 'stockRecord',
                 component: stockRecord,
                 name: '出入库记录',
                 meta: "device"
             }
    
         ]
     },*/

    {
        path: '/device',
        component: Layout,
        icon: 'el-icon-s-custom',
        showOnly: true,
        children: [{
            path: 'bleDevice',
            component: bleDevice,
            name: '蓝牙设备',
            meta: "BLE_DEVICE"
        },
        {
            path: 'operationRecord',
            component: bleDeviceOperationRecord,
            name: '操作记录',
            hidden: true,
            meta: ""
        }

        ]
    },

    {
        path: '/deviceBind',
        component: Layout,
        icon: 'el-icon-s-custom',
        showOnly: true,
        children: [{
            path: 'list',
            component: bleDeviceUser,
            name: '绑定关系',
            meta: "BLE_DEVICE"
        },

        ]
    },


    {
        path: '/shareRecord',
        component: Layout,
        icon: 'el-icon-s-custom',
        showOnly: true,
        children: [{
            path: 'list',
            component: shareRecordList,
            name: '分享记录',
            meta: "BLE_DEVICE"
        },

        ]
    },


    {
        path: '/generateCode',
        component: Layout,
        icon: 'el-icon-s-custom',
        showOnly: true,
        children: [{
            path: 'list',
            component: generateCode,
            name: '生成代码',
            meta: "BLE_DEVICE"
        },

        ]
    },




    {
        path: '/apiTest',
        component: Layout,
        icon: 'el-icon-s-custom',
        showOnly: true,
        children: [{
            path: 'test',
            component: apiTest,
            name: '接口测试',
            meta: "BLE_DEVICE"
        },

        ]
    },


    /*   {
         path: '/device/bleOperationRecord',
         component: Layout,
         icon: 'el-icon-s-custom',
         showOnly: true,
         children: [{
                 path: 'device',
                 component: bleOperationRecord,
                 name: '行车智友记录',
                 meta: "device"
             },
         ]
     },*/





    {
        path: '/admin',
        component: Layout,
        icon: 'el-icon-s-management',
        showOnly: true,
        children: [{
            path: 'category/list',
            component: categoryList,
            name: '类目管理',
            meta: "product-list"
        }

        ]
    },


    {
        path: '/admin',
        component: Layout,
        icon: 'el-icon-s-management',
        showOnly: true,
        children: [{
            path: 'product/list',
            component: productList,
            name: '产品管理',
            meta: "product-list"
        },
        {
            path: 'product/details',
            component: productDetails,
            name: '产品详情',
            hidden: true,
            meta: ""
        }

        ]
    },





    {
        path: '/admin/finance',
        component: Layout,
        redirect: '/admin/finance/income',
        icon: 'el-icon-s-finance',
        name: '店铺订单',
        meta: "caiwu",
        children: [
            { path: 'shopUnpaidOrderList', icon: 'el-icon-s-order', component: shopUnpaidOrderList, name: '待结账订单', meta: 'shourumingxi' },
            { path: 'incomeRefundList', icon: 'el-icon-notebook-2', component: incomeRefundList, name: '充值退款', meta: 'incomeRefundList' },
            { path: 'userWithdrawalList', icon: 'el-icon-notebook-1', component: userWithdrawalList, name: '提现审核', meta: 'depositList' },

        ]
    },






    {
        path: '/shop',
        component: Layout,
        icon: 'el-icon-s-management',
        redirect: '/shop/admin',
        meta: "shop",
        name: '店铺管理',
        children: [
            { path: 'shopList', icon: 'el-icon-user', component: pddShopList, name: '拼多多店', meta: 'shopList' },
            { path: 'otoShopList', icon: 'el-icon-user', component: shopList, name: '店铺列表', meta: 'otoShopList' },
            { path: 'banner', icon: 'el-icon-tickets', component: banner, name: '轮播管理', meta: 'sys-log' },
            {
                path: 'shopAuthCallback',
                component: shopAuthCallback,
                name: '店铺添加回调',
                hidden: true,
                meta: ""
            }

        ]
    },




    {
        path: '/tenant',
        component: Layout,
        icon: 'el-icon-s-management',
        showOnly: true,
        children: [{
            path: 'tenant/list',
            component: tenant,
            name: '应用管理',
            meta: "tenant_list"
        }


        ]
    },



    {
        path: '/pddOrder',
        component: Layout,
        icon: 'el-icon-s-management',
        redirect: '/order/admin',
        meta: "order",
        name: '拼多多订单',
        children: [
            { path: 'orderList', icon: 'el-icon-user', component: productionControl, name: '全部订单', meta: 'orderList' },
            { path: 'toBeShippedList', icon: 'el-icon-user', component: toBeShippedList, name: '待发货订单', meta: 'orderList' },
            { path: 'toolCommentInfoList/list', icon: 'el-icon-s-management', component: toolCommentInfoList, name: '评论管理', meta: 'product-list' },
        ]
    },


    /*  {
          path: '/admin',
          component: Layout,
          icon: 'el-icon-s-management',
          showOnly: true,
          children: [{
              path: 'test/testOrder',
              component: testOrder,
              name: '测试中心',
              meta: "test"
          }]
      },*/








    /*  {
         path: '/operating/business',
         component: Layout,
         redirect: '/admin/system/account-list',
         icon: 'el-icon-setting',
         name: '运营管理',
         meta: "sys",
         children: [
             { path: 'distributorList', icon: 'el-icon-user', component: distributorList, name: '经销商管理', meta: 'account' },
             { path: 'deviceReturnRent', icon: 'el-icon-s-custom', component: deviceReturnRent, name: '还租审核', meta: 'device-return-rent' },
    
    
         ]
     },*/


    /*   {
        path: '/trading/system',
        component: Layout,
        redirect: '/admin/system/account-list',
        icon: 'el-icon-setting',
        name: '交易系统',
        meta: "sys",
        children: [
            { path: 'account-list', icon: 'el-icon-user', component: AccountList, name: '交易订单', meta: 'account' },
            { path: 'role-list', icon: 'el-icon-s-custom', component: RoleList, name: '交易统计', meta: 'role' },
    
    
        ]
    },
    */


    {
        path: '/admin/finance',
        component: Layout,
        redirect: '/admin/finance/income',
        icon: 'el-icon-s-finance',
        name: '财务管理',
        meta: "caiwu",
        children: [
            { path: 'incomeList', icon: 'el-icon-s-order', component: incomeList, name: '充值订单', meta: 'shourumingxi' },
            { path: 'incomeRefundList', icon: 'el-icon-notebook-2', component: incomeRefundList, name: '充值退款', meta: 'incomeRefundList' },
            { path: 'userWithdrawalList', icon: 'el-icon-notebook-1', component: userWithdrawalList, name: '提现审核', meta: 'depositList' },

        ]
    },
    {
        path: '/admin/system',
        component: Layout,
        redirect: '/admin/system/account-list',
        icon: 'el-icon-setting',
        name: '系统管理',
        children: [
            { path: 'account-list', icon: 'el-icon-user', component: AccountList, name: '用户管理', meta: 'account' },
            { path: 'role-list', icon: 'el-icon-s-custom', component: RoleList, name: '角色管理', meta: 'role' },
            { path: 'operation-log', icon: 'el-icon-tickets', component: OperationLog, name: '操作日志', meta: 'account' },
            { path: 'sysPermission', icon: 'el-icon-tickets', component: sysPermission, name: '菜单配置',children:[],fdfsfa:"fasdfaf" },



        ]
    },

    { path: '*', redirect: '/login', hidden: true }
];


// WEBPACK FOOTER //
// ./src/router/index.js